import React from 'react'
import { Col, Row } from 'react-bootstrap';
import Loading from "../Loading/Loading";

export const TransactionControl = ({buttons, lastRead, isLoading}) => {

  if (isLoading) {
    return <Loading/>
  }

  return (
    <Row className="justify-content-center align-items-center">
      { 
        buttons && buttons.map(x => {
          return (
            <Col md={4}>{x}</Col>
          )
        })
      }
      <Col md={12} className="justify-self-center">
        {!lastRead && lastRead != null ? "" :
          <h4 className="text-center">{`Ultima leitura recebida do portal ${lastRead}`}</h4>
        }
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/component/Transaction/TransactionControl.js